"use client";

import {Swiper, SwiperSlide} from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import {Autoplay, Navigation, Pagination} from "swiper/modules";
import MainSlider from "@/src/_types/main-slider";
import {Box, Typography} from "@mui/material";
import Image from "next/image";
import MainJournalSliderCard
    from "@/src/components/main-site/home/custom-mui/main-journal-slider-card/main-journal-slider-card";
import NextLink from 'next/link';
import Link from '@mui/material/Link';

export default function MainJournalSlider({journal}: { journal: any }) {
    const mainSlider: MainSlider[] = journal.options?.template_configs?.main_site_slider;

    return (
        <MainJournalSliderCard id="sliders"
                               sx={{
                                   padding: {
                                       xs: "1rem 2rem",
                                       sm: "1rem 2rem",
                                       md: "1rem 2rem",
                                       lg: "1rem 0",
                                       xl: "1rem 0"
                                   }
                               }}
        >
            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                navigation
                pagination={{clickable: true}}
                spaceBetween={20}
                slidesPerView={1}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                slidesPerGroup={1}
                breakpoints={{
                    640: {slidesPerView: 1},
                    768: {slidesPerView: 1},
                    1024: {slidesPerView: 1},
                    1280: {slidesPerView: 1},
                }}
            >
                {mainSlider && mainSlider.length > 0 && mainSlider.map((slider, key) => (
                    <SwiperSlide key={key}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            flexDirection: {xs: 'column', sm: 'column', md: 'row', lg: 'row', xl: 'row'},
                            justifyContent: 'space-between'
                        }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.2,
                                    flexDirection: {xl: 'column', xs: 'row'},
                                    justifyContent: 'center',
                                    flex: '1 1 auto',
                                    ' img': {
                                        width: {xs: '100%', sm: '100%', md: '100%', lg: 'auto', xl: 'auto'},
                                        height: {xs: 'auto', sm: 'auto', md: 'auto', lg: 'auto', xl: 'auto'},
                                    },
                                }}
                            >
                                <Image src={slider.image?.url ?? ''} alt={slider.slide?.label ?? ''} width={'860'}
                                       height={'280'}/>
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.2,
                                    flexDirection: {
                                        xs: 'column',
                                        sm: 'column',
                                        md: 'column',
                                        lg: 'column',
                                        xl: 'column'
                                    },
                                    justifyContent: 'center',
                                    flex: '1 1 auto'
                                }}
                            >
                                <Typography
                                    component="h2"
                                    sx={{
                                        textAlign: "left",
                                        fontWeight: 900,
                                        lineHeight: 1,
                                        fontSize: {
                                            xs: '1.5rem',
                                            sm: '1.5rem',
                                            md: '1.5rem',
                                            lg: '2.5rem',
                                            xl: '2.5rem'
                                        },
                                        color: (theme) => theme.palette.custom?.darkGray
                                    }}>
                                    {slider.slide?.label}
                                </Typography>
                                <Typography variant="fs7" component="p"
                                            sx={{
                                                textAlign: "left",
                                                color: (theme) => theme.palette.custom?.darkGray,
                                                fontWeight: 500,
                                                fontSize: {
                                                    xs: '.9rem',
                                                    sm: '.9rem',
                                                    md: '1rem',
                                                    lg: '1rem',
                                                    xl: '1rem'
                                                },
                                            }}>
                                    {slider.slide?.caption}
                                </Typography>
                                <Link
                                    target={'_blank'}
                                    style={{
                                        background: '#009963',
                                        maxWidth: '400px',
                                        borderRadius: '24px',
                                        padding: '.5rem',
                                        display: 'display',
                                        width: '100%',
                                        textAlign: 'center',
                                        fontWeight: '700',
                                        fontSize: 16,
                                        textDecoration: 'none',
                                        color: 'white',
                                    }}
                                    component={NextLink}
                                    href={slider.button?.url ?? '#'}
                                >
                                    {slider.button?.label}
                                </Link>
                            </Box>
                        </Box>
                    </SwiperSlide>
                ))}
            </Swiper>
        </MainJournalSliderCard>
    );
}
